
import CustomSweetAlert from 'components/Shared/CustomSweetAlert';
import React, { useState, useEffect } from 'react';
import { Button } from "react-bootstrap";

const VideoViewComponent = (props) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [alert, setAlert] = useState(null);
    const [induction, setInduction] = useState(null);
    const [isComfirm, setIsConfirm] = useState(false);
    useEffect(() => {
        if (props?.inductionItem) {
            setInduction(props.inductionItem);
            setIsConfirm(props.inductionItem.isCompleted)
        }
    }, [props]);

    const handleConfirm = async () => {
        try {
            setAlert(CustomSweetAlert({ type: "loading" }));
            const url = induction?.postAPI;
            const method = `PUT`;
            const response = await fetch(apiURL + url, {
                method,
                headers: [
                    ["Content-Type", "application/json"],
                    ["Content-Type", "text/plain"]
                ],
            });
            if (response.status === 200) {
                setAlert(CustomSweetAlert({
                    type: "success", title: "Success", message: "The update has been successfully",
                    onConfirm: () => {
                        hideAlert();
                        setIsConfirm(true);
                        props.handleClose(induction?.key);
                    }, showCancel: false
                }));

            } else {
                showErrorAlert(`Failed to update data`);
            }
        } catch (e) {
            showErrorAlert(`Failed to update data`);
        }
    }

    const showErrorAlert = (message) => setAlert(CustomSweetAlert({
        type: "error", title: "Error", message: message,
        onConfirm: () => {
            hideAlert();
        }, showCancel: false
    }));

    const hideAlert = () => setAlert(null);

    return (
        <div>
            {alert}
            {induction &&
                <>
                    <div style={{ width: "100%", height: "500px" }}>
                        <iframe
                            src={induction?.link}
                            allow='autoplay;fullscreen;picture-in-picture'
                            allowFullScreen
                            title='2. FPMcCann HSE Induction v3'
                            style={{ width: "100%", height: "100%" }}
                        />
                    </div>
                    <Button
                        className="btn-link d-flex justify-content-start pt-2"
                        size="lg"
                        style={{ margin: "0px", padding: "0px", color: isComfirm ? "#87cb16" : "#888888", textDecoration: "none" }}
                        onClick={() => setIsConfirm(!isComfirm)}
                    >
                        <i className={`far ${isComfirm ? "fa-check-square" : "fa-square"} mx-3 pt-1`}></i>
                        <p style={{ fontSize: "17px", marginBottom: 0, textAlign: 'left' }}>I confirm I have watched and understand the content
                            of this video and acknowledge that questions will be ask surrounding the content of this video on my first day</p>
                    </Button>
                    <div className='d-flex justify-content-end'>
                        <Button className="btn-lg" variant='save' disabled={!isComfirm} onClick={handleConfirm}>
                            Save and Close
                        </Button>
                    </div>
                </>
            }
        </div>
    );
}

export default VideoViewComponent;